import { useEffect } from "react";
import { useUIStore } from "../../stores/ui/uiStore";

export function useWindowResizeSync() {
    const setWindowWidth = useUIStore(state => state.setWindowWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        handleResize(); // initial sync

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [setWindowWidth]);
}